export function newHeaders() {
	const accessToken = localStorage.getItem('cicekToken');
	const bearer = `Bearer ${accessToken}`;

	return {
		'Accept': 'application/json',
		'Content-Type': 'application/json',
		'Authorization': bearer
	};
}
